(function () {
   angular.module('com.vmware.vsphere.client.vm')
         .service('vmDatastoreLocationBrowserService', vmDatastoreLocationBrowserService);

   vmDatastoreLocationBrowserService.$inject = [
       '$q',
       'i18nService',
       'dataService',
       'clarityModalService',
       'defaultUriSchemeUtil',
       'authorizationService',
       'storageLocatorService'
   ];

   function vmDatastoreLocationBrowserService(
       $q,
       i18nService,
       dataService,
       clarityModalService,
       defaultUriSchemeUtil,
       authorizationService,
       storageLocatorService
   ) {
      return {
         getStorageLocatorItems: function (vmId) {
            return getResourceId(vmId).then(function(result) {
               return storageLocatorService.getStorageLocatorData(result.resourceId);
            });
         },
         choose: function (scope, options) {
            var deferredSelection = $q.defer();

            var modalOptions = {
               storageData: options.storageData,
               storageProfilesData: options.storageProfilesData,
               disableSdrs: options.disableSdrs,
               comparatorWrapper: options.comparatorWrapper,
               preselectItem: options.preselectItem,
               onSelectionChanged: function (selectedItem) {
                  modalOptions.submitDisabled = !selectedItem;
               },
               title: i18nService.getString('Common', 'StorageLocatorDialog.Title'),
               contentTemplate: 'vm-ui/resources/vm/views/settings/vmHardwareSettings/vmHardwareVirtualDisk/vmDatastoreLocationBrowserDialog.html',
               defaultButton: 'submit',
               size: 'lg',
               hideSubmitButton: false,
               submitDisabled: true,
               modalClass: 'vmDataStoreLocationBrowserDialog',
               onCancel: function() {
                  deferredSelection.reject();
                  return true;
               }
            };

            modalOptions.onSubmit = function() {
               deferredSelection.resolve({
                  selectedStorageItem: {
                     storageObject: modalOptions.storageData.selectedStorageItem,
                     name: modalOptions.storageData.selectedStorageItem.name,
                     id: defaultUriSchemeUtil.getVsphereObjectId(modalOptions.storageData.selectedStorageItem.storageRef)
                  },
                  selectedStorageProfile: modalOptions.storageProfilesData.selectedProfile
               });
               return true;
            };

            clarityModalService.openOkCancelModal(modalOptions);

            return deferredSelection.promise;
         }
      };

      function getResourceId(vmId) {
         return dataService
            .getProperties(vmId, 'host')
            .then(function(response) {
               var hostId = defaultUriSchemeUtil.getVsphereObjectId(response.host);
               return $q.all({
                  hasReadOnHost: authorizationService
                        .checkGrantedPrivilege(hostId, 'System.Read'),
                  vmHost: hostId
               });
            })
            .then(function(response) {
               return {
                  // If no System.Read on host the use the vmId to extract datastores from
                  // VM environment browser.
                  resourceId: response.hasReadOnHost ? response.vmHost : vmId
               };
            });
      }
   }
})();
